import { z } from 'zod';
import { entityIdSchema, nonEmptyTextSchema, sha256Schema, utcDateTimeSchema, } from '@kop/contracts';
export const historicalTbmPhotoSchema = z
    .object({
    legacyReferenceSha256: sha256Schema,
    manifestId: entityIdSchema,
    sourceSha256: sha256Schema,
    thumbnailSha256: sha256Schema,
    evidenceSha256: sha256Schema,
})
    .strict();
export const historicalDailyTbmRecordSchema = z
    .object({
    recordKind: z.literal('historical-daily-tbm'),
    recordId: entityIdSchema,
    tenantId: z.literal('kop'),
    siteId: z.literal('site-eumseong'),
    contractorId: entityIdSchema,
    contractorName: nonEmptyTextSchema.max(300),
    businessDate: z.iso.date(),
    facilitatorName: nonEmptyTextSchema.max(200).nullable(),
    workCategoryLabel: nonEmptyTextSchema.max(300),
    places: z.array(nonEmptyTextSchema.max(300)).max(30),
    mainWorks: z.array(nonEmptyTextSchema.max(500)).max(30),
    hazardLabels: z.array(nonEmptyTextSchema.max(300)).max(30),
    healthCheckSnapshot: z.string().trim().max(200).nullable(),
    ppeCheckSnapshot: z.string().trim().max(200).nullable(),
    attendanceCount: z.number().int().nonnegative(),
    headcountByPlace: z.record(z.string(), z.number().int().nonnegative()),
    dissemination: z.string().trim().max(2_000).nullable(),
    photos: z.array(historicalTbmPhotoSchema).max(6),
    evidenceIssues: z
        .array(z.enum([
        'MISSING_FACILITATOR',
        'MISSING_WORK',
        'MISSING_HAZARD',
        'MISSING_ATTENDANCE',
        'MISSING_MEDIA',
        'UNVERIFIED_MEDIA',
    ]))
        .max(6),
    representativeSignatureObserved: z.boolean(),
    attendanceProof: z.literal('legacy-count-only'),
    optionalReferences: z.array(z.never()).length(0),
    source: z
        .object({
        projectId: z.literal('safety-management-c7518'),
        collection: z.literal('tbmReports_V6'),
        documentId: nonEmptyTextSchema.max(500),
        sourceSnapshotSha256: sha256Schema,
        exportRootSha256: sha256Schema,
    })
        .strict(),
    immutable: z.literal(true),
    operationalEligible: z.literal(false),
    importedAt: utcDateTimeSchema,
    contentHash: sha256Schema,
})
    .strict();
export const historicalDailyTbmBoardSchema = z
    .object({
    recordKind: z.literal('historical-daily-tbm-board'),
    tenantId: z.literal('kop'),
    siteId: z.literal('site-eumseong'),
    businessDate: z.iso.date(),
    weather: z.string().trim().max(200).nullable(),
    summary: z.string().trim().max(2_000).nullable(),
    note: z.string().trim().max(4_000).nullable(),
    companySnapshots: z.array(z
        .object({
        contractorName: nonEmptyTextSchema.max(300),
        attendanceCount: z.number().int().nonnegative(),
        mainWork: z.string().trim().max(2_000).nullable(),
    })
        .strict()),
    totalAttendanceSnapshot: z.number().int().nonnegative(),
    sourceSnapshotSha256: sha256Schema,
    immutable: z.literal(true),
    importedAt: utcDateTimeSchema,
    contentHash: sha256Schema,
})
    .strict();
